const getDefaultState = () => {
    return {
        timeTocallFieldOptions: [],
        timeTocallTurnoverOptions: [],
        timeTocallJobOptions: [],
        salutationOptions: [],
        timeTocallValuechainOption: []
    }
}

const state = getDefaultState()

// getters
const getters = {
    timeTocallFieldOptions: (state) => {
        state.timeTocallFieldOptions = [
            { value: 'checkResult:form.labels.dropdownMenu.jobTitles.owner', label: 'checkResult:form.labels.dropdownMenu.jobTitles.owner' },
            { value: 'checkResult:form.labels.dropdownMenu.jobTitles.management', label: 'checkResult:form.labels.dropdownMenu.jobTitles.management' },
            { value: 'checkResult:form.labels.dropdownMenu.jobTitles.staff', label: 'checkResult:form.labels.dropdownMenu.jobTitles.staff' }
        ]
        return state.timeTocallFieldOptions
    },
    timeTocallTurnoverOptions: (state) => {
        state.timeTocallTurnoverOptions = [
            { value: '< 3', label: 'checkResult:form.labels.dropdownMenu.turnover.range1' },
            { value: '3-5', label: 'checkResult:form.labels.dropdownMenu.turnover.range2' },
            { value: '5-10', label: 'checkResult:form.labels.dropdownMenu.turnover.range3' },
            { value: '10-20', label: 'checkResult:form.labels.dropdownMenu.turnover.range4' },
            { value: '20-50', label: 'checkResult:form.labels.dropdownMenu.turnover.range5' },
            { value: '>50', label: 'checkResult:form.labels.dropdownMenu.turnover.range6' }
        ]
        return state.timeTocallTurnoverOptions
    },
    timeTocallJobOptions: (state) => {
        state.timeTocallJobOptions = [
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.chemicalIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.chemicalIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.constructionIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.constructionIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.consumerGoods', label: 'checkResult:form.labels.dropdownMenu.companyFields.consumerGoods' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.electronics', label: 'checkResult:form.labels.dropdownMenu.companyFields.electronics' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.financialServices', label: 'checkResult:form.labels.dropdownMenu.companyFields.financialServices' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.foodIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.foodIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.it', label: 'checkResult:form.labels.dropdownMenu.companyFields.it' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.machineIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.machineIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.media', label: 'checkResult:form.labels.dropdownMenu.companyFields.media' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.metalIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.metalIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.foodIndustry', label: 'checkResult:form.labels.dropdownMenu.companyFields.foodIndustry' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.pharma', label: 'checkResult:form.labels.dropdownMenu.companyFields.pharma' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.realEstate', label: 'checkResult:form.labels.dropdownMenu.companyFields.realEstate' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.retail', label: 'checkResult:form.labels.dropdownMenu.companyFields.retail' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.tourism', label: 'checkResult:form.labels.dropdownMenu.companyFields.tourism' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.transport', label: 'checkResult:form.labels.dropdownMenu.companyFields.transport' },
            { value: 'checkResult:form.labels.dropdownMenu.companyFields.other', label: 'checkResult:form.labels.dropdownMenu.companyFields.other' }
        ]
        return state.timeTocallJobOptions
    },
    salutationOptions: (state) => {
        state.salutationOptions = [
            { value: 'mrs', label: 'checkResult:form.labels.salutation.mrs' },
            { value: 'mr', label: 'checkResult:form.labels.salutation.mr' }
        ]
        return state.salutationOptions
    },
    timeTocallValuechainOption: (state) => {
        state.timeTocallValuechainOption = [
            { value: 'checkResult:form.labels.dropdownMenu.valueChain.trade', label: 'checkResult:form.labels.dropdownMenu.valueChain.trade' },
            { value: 'checkResult:form.labels.dropdownMenu.valueChain.production', label: 'checkResult:form.labels.dropdownMenu.valueChain.production' },
            { value: 'checkResult:form.labels.dropdownMenu.valueChain.service', label: 'checkResult:form.labels.dropdownMenu.valueChain.service' }
        ]
        return state.timeTocallValuechainOption
    }
}

export default {
    namespaced: true,
    state,
    getters
}
